<template>
  <div id="app" class="v-application--wrap layout-clean" :class="layoutClass">
    <slot name="header" v-if="hasHeaderSlot">
      <header class="header">
        <img width="130" :alt="extendedConfig.VUE_MAIN_TITLE" src="../assets/kr.png" />
      </header>
    </slot>
    <v-content>
      <v-container fluid fill-height>
        <v-layout :align-center="layoutAlignCenter" :justify-center="layoutJustifyCenter" :flex-wrap="layoutFlexWrap">
          <slot>
            <router-view />
          </slot>
        </v-layout>
      </v-container>
    </v-content>
    <slot name="footer" v-if="hasFooterSlot">
      <footer class="footer">
        © {{ new Date().getFullYear() }} by {{extendedConfig.VUE_MAIN_TITLE}}. 
      </footer>
    </slot>
    <v-snackbar :value="!!notificationSnackbarText" @input="onSnackbarInput">
      <div v-html="notificationSnackbarText"></div>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="hideSnackbarNotification"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import extendedConfig from "../tenants.js";
import { mapMutations, mapState } from 'vuex';
export default {
  name: "LayoutClean",
  props: {
    layoutClass: {
      type: String,
      default: ''
    },
    layoutAlignCenter: {
      type: Boolean,
      default: true
    },
    layoutJustifyCenter: {
      type: Boolean,
      default: true
    },
    layoutFlexWrap: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  data: () => ({
    //
  }),
  computed: {
    ...mapState('appStates', ['notificationSnackbarText']),
    hasHeaderSlot() {
      return !!this.$slots.header;
    },
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
  },
  methods: {
    ...mapMutations('appStates', ['hideSnackbarNotification']),
    onSnackbarInput(isVisible) {
      if (!isVisible && this.notificationSnackbarText) {
        this.hideSnackbarNotification()
      }
    },
  }
};
</script>
<style lang="scss">
.layout-clean {
  .header {
    position: relative;
    padding: 12px;

    @media (min-width: 768px) {
      padding: 12px 18px;
    }
  }

  .footer {
    position: relative;
    padding: 12px;

    @media (min-width: 768px) {
      padding: 12px 18px;
    }
  }
}
</style>
